<div class="kpi-dialog">
  <h3 class="kpi-dialog-title">New KPI creation</h3>

  <div class="kpi-dialog-options" role="radiogroup" aria-label="New KPI mode">
    <label class="kpi-dialog-option" [class.is-selected]="OpcNew === '0'">
      <input type="radio" name="OpcNew" value="0" [(ngModel)]="OpcNew" />
      <span class="kpi-dialog-option-text">
        <strong>Default values</strong>
        <span class="kpi-dialog-option-hint">Create a new KPI with mostly default values, GF "<u>{{ SelectedGF }}</u>" and empty breakdowns.</span>
      </span>
    </label>
    <label class="kpi-dialog-option" [class.is-selected]="OpcNew === '1'">
      <input type="radio" name="OpcNew" value="1" [(ngModel)]="OpcNew" />
      <span class="kpi-dialog-option-text">
        <strong>Copy of selected KPI</strong>
        <span class="kpi-dialog-option-hint">Create a new KPI as a copy from [{{ KpiDefinitionId }}] "<u>{{ KpiName }}</u>" and GF "<u>{{ SelectedGF }}</u>" values and breakdowns.</span>
      </span>
    </label>
  </div>

  <div class="kpi-dialog-fields">
    <label class="kpi-field">
      <span class="kpi-field-label">Account (MersyID)</span>
      <input class="kpi-input" maxlength="50" type="text" [(ngModel)]="NEWMersyId" />
    </label>
    <label class="kpi-field">
      <span class="kpi-field-label">Kpi Name</span>
      <input class="kpi-input" maxlength="100" type="text" [(ngModel)]="NEWKpiName" />
    </label>
  </div>

  <div class="kpi-dialog-actions">
    <button type="button" mat-raised-button class="btn button-color-fix_red" (click)="onNoClick()">
      <mat-icon class="icon-color-fix">arrow_back_ios</mat-icon>
      Back
    </button>
    <button type="button" mat-raised-button class="btn button-color-fix" [disabled]="!isFormValid() || isSubmitting" (click)="onSubmit()">
      Create
      <mat-icon class="icon-color-fix">save</mat-icon>
    </button>
  </div>
</div>
